// extracted by mini-css-extract-plugin
export default {"cls1":"VxPQqByVM9_qPWtosuyi","cls2":"KQeyfPI2evUJlhxE3uVs VxPQqByVM9_qPWtosuyi"};